import createModel from "../createModel";

export const UniqaClaimAddress = createModel("UniqaClaimAddress", (json) => ({
    city: json.city,
    street: json.street,
    zipCode: json.zipCode,
    placeDescription: json.placeDescription,
}));
